import React, { useEffect, useState } from 'react';
import TextButton from 'components/TextButton';
import tickIcon from 'resources/Button-Check-selected.svg';
import { avatarKeyMap, getImageWithBackground, imagesWithBg } from '../utils';

const AvatarSelector = props => {
  const avatarList = imagesWithBg;

  const [selectedAvatar, setSelectedAvatar] = useState('');

  useEffect(() => {
    if (
      props.userData &&
      props.userData.user &&
      props.userData.user.avatarData
    ) {
      const selectedAvatarKey = Object.entries(avatarKeyMap).find(
        ([key, value]) => value === props.userData.user.avatarData
      )?.[0];
      setSelectedAvatar(getImageWithBackground(selectedAvatarKey));
    }
  }, [props.userData]);

  const handleAvatarSelect = avatar => {
    setSelectedAvatar(avatar);
    props.onSelect && props.onSelect(avatar);
  };

  const [defaultAvatar] = Object.entries(avatarKeyMap).find(
    ([, value]) => value === 'default'
  );
  const filteredAvatarList = avatarList.filter(
    avatar => !avatar.includes(defaultAvatar)
  );

  return (
    <div className="avatar-list">
      {filteredAvatarList.map((avatar, index) => (
        <TextButton
          key={index}
          className={`avatar-item ${
            avatar === selectedAvatar ? 'selected' : ''
          }`}
          onClick={() => handleAvatarSelect(avatar)}
        >
          <img
            src={avatar}
            alt={`Avatar ${index}`}
            className={avatar === selectedAvatar ? 'selected' : ''}
          />
          {avatar === selectedAvatar && (
            <img src={tickIcon} className="tick-icon" alt="selected avatar" />
          )}
        </TextButton>
      ))}
    </div>
  );
};

export default AvatarSelector;
